/* JA名 */
import React, { memo } from 'react';
import { FormControl } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
import Paragraph from './Paragraph';

interface Props {
  id: string;
  fm_id?: number;
  label: string;
  need?: boolean;
  value: string;
  placeholder: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  message?: string;
  name?: string;
  help_msg?: string;
  disabled: boolean;
  looks_inactive?: boolean;
  maxlength?: number;
  handleBlur?: VoidFunction;
  readonly?: boolean;
}

const JaName: React.FC<Props> = ({
  id,
  fm_id,
  label,
  need,
  value,
  placeholder,
  handleChange,
  message,
  name,
  help_msg,
  disabled,
  maxlength,
  handleBlur,
  looks_inactive,
  readonly,
}) => {
  /**
   * ラベルを描画する
   * @return JSX.Element ラベルのElement
   */
  const returnLabelJsx = () => {
    return <Paragraph label={value} />;
  };

  /**
   * 通常のJaNameを描画する
   * @return JSX.Element ラベルのElement
   */
  const returnJaNameJsx = () => {
    return (
      <div id={id} className="janame-content">
        <FormControl
          className={`${message && 'textarea-error'}`}
          id={id}
          data-fm_id={fm_id}
          type="text"
          placeholder={placeholder}
          value={value !== null && typeof value !== 'undefined' ? value : ''}
          onChange={handleChange}
          name={name}
          disabled={disabled || readonly}
          onBlur={handleBlur}
          maxLength={maxlength}
        />
        <Messages help_msg={help_msg} valid_msg={message} />
      </div>
    );
  };

  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      looks_inactive={looks_inactive}
      content={disabled || looks_inactive ? returnLabelJsx() : returnJaNameJsx()}
    />
  );
};

export default memo(JaName);
